import React from "react";
import LightBox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import ImageMetaData from "../../../../../common/ProImages/components/Popup/components/ImageMetaData";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    overflowX: "auto",
    flex: 1,
  },
  notAvailable: { opacity: 0.5, flex: 1, textAlign: "center" },
  image: {
    padding: 4,
    width: "220",
    height: "260",
  },
  containerStart: {
    alignItems: "flex-start",
  },
  containerCenter: {
    alignItems: "center",
    justifyContent: "center",
    color: theme.iconColor
  },
});

class ImageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lightBox: null,
    };
  }

  showLightBox = (startIndex) => {
    this.setState({
      lightBox: { startIndex },
    });
  };

  hideLightBox = () => {
    this.setState({
      lightBox: null,
    });
  };

  getImageList = (imageURLDetailsByTimestamp) => {
    return this.props.images.map((imgData, index) => ({
      key: imgData.key,
      url: imgData.blobData,
      title: `${this.props.label} (${index + 1})`,
      ...imageURLDetailsByTimestamp[imgData.key],
    }));
  };

  render() {
    const { classes, imageURLDetailsByTimestamp } = this.props;
    const imageList = this.getImageList(imageURLDetailsByTimestamp);
    const images = imageList.length > 1 ? imageList : undefined;
    const imageInfo = imageList.length === 1 ? imageList[0].url : undefined;
    const title = imageList.length === 1 ? imageList[0].title : undefined;
    return (
      <div
        className={`${classes.container} ${
          imageList?.length ? classes.containerStart : classes.containerCenter
        }`}
      >
        {imageList.length ? (
          imageList.map((image, index) => (
            <ImageMetaData
              key={image?.timestamp ?? index}
              date={image?.date}
              time={image?.time}
              address={image?.address}
            >
              <img
                src={image.url}
                alt={image.title}
                key={image.title}
                className={classes.image}
                onClick={() => this.showLightBox(index)}
              />
            </ImageMetaData>
          ))
        ) : (
          <div className={classes.classes}>Not Available</div>
        )}
        {this.state.lightBox ? (
          <LightBox
            images={images}
            image={imageInfo}
            title={title}
            startIndex={this.state.lightBox.startIndex}
            onClose={this.hideLightBox}
          />
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(ImageList);
